export * from '@fhs/routing/src/routes/claim-points/_layout';
export { default } from '@fhs/routing/src/routes/claim-points/_layout';
